/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Standards_Preset_Save_Failed_ToastInputs */

const en_standards_preset_save_failed_toast = /** @type {(inputs: Standards_Preset_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
};

const fr_standards_preset_save_failed_toast = /** @type {(inputs: Standards_Preset_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
};

const de_standards_preset_save_failed_toast = /** @type {(inputs: Standards_Preset_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
};

const it_standards_preset_save_failed_toast = /** @type {(inputs: Standards_Preset_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
};

const ru_standards_preset_save_failed_toast = /** @type {(inputs: Standards_Preset_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
};

const es_standards_preset_save_failed_toast = /** @type {(inputs: Standards_Preset_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
};

const zh_cn2_standards_preset_save_failed_toast = /** @type {(inputs: Standards_Preset_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
};

const ja_standards_preset_save_failed_toast = /** @type {(inputs: Standards_Preset_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
};

const hi_standards_preset_save_failed_toast = /** @type {(inputs: Standards_Preset_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
};

const pt_pt2_standards_preset_save_failed_toast = /** @type {(inputs: Standards_Preset_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to save preset: {error}" |
*
* @param {Standards_Preset_Save_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_save_failed_toast = /** @type {((inputs: Standards_Preset_Save_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Save_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_standards_preset_save_failed_toast(inputs)
	if (locale === "de") return de_standards_preset_save_failed_toast(inputs)
	if (locale === "it") return it_standards_preset_save_failed_toast(inputs)
	if (locale === "ru") return ru_standards_preset_save_failed_toast(inputs)
	if (locale === "es") return es_standards_preset_save_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_standards_preset_save_failed_toast(inputs)
	if (locale === "ja") return ja_standards_preset_save_failed_toast(inputs)
	if (locale === "hi") return hi_standards_preset_save_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_standards_preset_save_failed_toast(inputs)
	return en_standards_preset_save_failed_toast(inputs)
});